/////////////////////////////////////////////////////////////////////////////////////////////////////////
// 화일명 : useClickOutside.ts
// 지정한 ref 영역 바깥을 클릭했을 때 콜백을 실행하는 공통 훅
//  - enabled가 false면 리스너를 등록하지 않음 (드롭다운이 닫혀있을 때 불필요한 리스너 방지)
/////////////////////////////////////////////////////////////////////////////////////////////////////////
import { useEffect, useRef } from 'react';

export function useClickOutside(
  ref: React.RefObject<HTMLElement | null>,
  onOutside: () => void,
  enabled: boolean = true
) {
  // 매 렌더마다 새로 만들어지는 콜백이어도 리스너를 재등록하지 않도록 ref로 최신값만 추적
  const onOutsideRef = useRef(onOutside);
  onOutsideRef.current = onOutside;

  useEffect(() => {
    if (!enabled) return;
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as Node;
      if (ref.current && !ref.current.contains(target)) {
        onOutsideRef.current();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [enabled, ref]);
}
